"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChocolatesContext = exports.defaultConfig = void 0;
var react_1 = __importDefault(require("react"));
exports.defaultConfig = {
    ssr: false,
    setConfig: function () {
        throw new Error('Must be wrapped in Chocolates Context');
    },
    onTrack: function () {
        throw new Error('onTrack must be defined in Chocolates Context');
    },
    apiBase: (_a = process.env.NEXT_PUBLIC_API_BASE) !== null && _a !== void 0 ? _a : 'https://zoltar.staging.gethank.com',
};
exports.ChocolatesContext = react_1.default.createContext(exports.defaultConfig);
//# sourceMappingURL=config.js.map